import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationRemindersService {
  private apiUrl = environment.apiURL + 'notification-reminders';
  private ordersApiUrl = environment.apiURL + 'orders';

  constructor(private http: HttpClient) {}

  // --- ABM de plantillas (Admin) ---

  getReminders(params: any = {}): Observable<any> {
    return this.http.get(this.apiUrl, { params });
  }

  getReminder(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  createReminder(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, body);
  }

  updateReminder(reference: string, body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}/update`, body);
  }

  deleteReminder(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }

  // --- Asignación en órdenes (cualquier usuario) ---

  assignToOrder(orderReference: string, reminderPayload: any): Observable<any> {
    return this.http.post(`${this.ordersApiUrl}/${orderReference}/notification-reminders`, {
      reference: reminderPayload,
    });
  }

  removeFromOrder(orderReference: string, reminderReferences: string | string[]): Observable<any> {
    return this.http.delete(`${this.ordersApiUrl}/${orderReference}/notification-reminders`, {
      body: { reference: reminderReferences },
    });
  }
}
